import b from "./design-system.es44.js";
import { resolveComponent as f, openBlock as a, createElementBlock as c, Fragment as k, renderList as v, createBlock as m, withCtx as h, renderSlot as p, createCommentVNode as n, createTextVNode as A } from "vue";
/* empty css                    */
import y from "./design-system.es128.js";
const V = {
  name: "DsCheckboxGroup",
  components: {
    Checkbox: b
  },
  props: {
    /**
     * Collection of checkboxes to display in the group
     */
    boxes: {
      type: Array,
      required: !0
    },
    /**
     * Represents the label property to display next to the checkboxes in the group
     */
    labelProp: {
      type: String,
      default: "label"
    },
    /**
     * Determines which value property to pass into the checkboxes in the group
     */
    valueProp: {
      type: String,
      default: "value"
    },
    /**
     * An object that describes the state of the "selectAll" checkbox
     */
    selectAll: {
      type: Object,
      default: null
    },
    /**
     * An array of checkbox objects that determines the state of each checkbox in the group
     */
    modelValue: {
      type: [Array, String],
      required: !0,
      default: () => []
    },
    /**
     * Required field for validation purposes
     */
    required: Boolean
  },
  emits: ["update:modelValue"],
  computed: {
    allSelected() {
      return this.modelValue.length === this.boxes.length;
    },
    someSelected() {
      const l = this.modelValue.length;
      return l > 0 && l < this.boxes.length;
    },
    displayBoxes() {
      const {
        boxes: l,
        modelValue: t,
        valueProp: e,
        labelProp: o
      } = this;
      return l.map((s) => {
        const d = s[e];
        return {
          ...s,
          value: d,
          label: s[o],
          checked: t.includes(s[e])
        };
      });
    }
  },
  methods: {
    handleChange(l) {
      const { modelValue: t } = this, e = this.displayBoxes.map((o) => o.value).filter((o) => l === o ? !t.includes(o) : t.includes(o));
      this.$emit("update:modelValue", e);
    },
    handleSelectAll() {
      const l = this.someSelected || this.allSelected ? [] : this.displayBoxes.map((t) => t.value);
      this.$emit("update:modelValue", l);
    }
  }
}, _ = { class: "checkbox-group" }, S = { key: 0 }, g = { key: 0 };
function C(l, t, e, o, s, d) {
  const i = f("Checkbox");
  return a(), c("div", _, [
    (a(!0), c(k, null, v(d.displayBoxes, (r, u) => (a(), m(i, {
      key: u,
      "model-value": r.checked,
      label: r.label,
      error: r.error,
      disabled: r.disabled,
      required: r.required,
      color: r.color,
      "border-color": r["border-color"],
      "icon-color": r["icon-color"],
      "onUpdate:modelValue": (q) => d.handleChange(r.value)
    }, {
      default: h(() => [
        l.$slots[`checkbox${u}`] ? (a(), c("div", S, [
          p(l.$slots, `checkbox${u}`, {}, void 0, !0)
        ])) : n("", !0)
      ]),
      _: 2
    }, 1032, ["model-value", "label", "error", "disabled", "required", "color", "border-color", "icon-color", "onUpdate:modelValue"]))), 128)),
    t[0] || (t[0] = A()),
    e.selectAll || l.$slots.selectAll ? (a(), m(i, {
      key: 0,
      label: e.selectAll ? e.selectAll[e.labelProp] : "",
      error: e.selectAll ? e.selectAll.error : !1,
      disabled: e.selectAll ? e.selectAll.disabled : !1,
      required: e.selectAll ? e.selectAll.required : !1,
      partial: d.someSelected,
      "model-value": d.allSelected,
      "onUpdate:modelValue": d.handleSelectAll
    }, {
      default: h(() => [
        l.$slots.selectAll ? (a(), c("div", g, [
          p(l.$slots, "selectAll", {}, void 0, !0)
        ])) : n("", !0)
      ]),
      _: 3
    }, 8, ["label", "error", "disabled", "required", "partial", "model-value", "onUpdate:modelValue"])) : n("", !0)
  ]);
}
const G = /* @__PURE__ */ y(V, [["render", C], ["__scopeId", "data-v-44101a06"]]);
export {
  G as default
};
//# sourceMappingURL=design-system.es46.js.map
